import { jsPDF } from 'jspdf';
import { formatDisplayDate } from './dashboardData';
import { formatKilos, formatPercent } from './flujoCalculations';
import { drawPdfReportHeader, loadPdfReportLogo } from './pdfReportHeader';

const dark = [21, 25, 29];
const muted = [104, 114, 125];
const orange = [255, 121, 0];
const divider = [220, 224, 228];

const rows = [
  { label: 'Kilos volcados', field: 'kilosVolcados' },
  { label: 'Precalibrado', field: 'precalibrado', percentage: 'precalibrado' },
  { label: 'Retorno', field: 'retorno', percentage: 'retorno' },
  { label: 'Verde', field: 'verde', percentage: 'verde' },
  { label: 'Rendimiento', percentage: 'rendimiento', emphasis: true },
  { label: 'Kilos reales', field: 'kilosReales', dividerBefore: true },
  { label: 'Primera', field: 'primera', percentage: 'primera' },
  { label: 'Industria', field: 'industria', percentage: 'industria' },
  { label: 'Podrido', field: 'podrido', percentage: 'podrido' },
  { label: 'Mermas', percentage: 'mermas', emphasis: true },
];

const filenamePart = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-zA-Z0-9]+/g, '-')
  .replace(/^-|-$/g, '')
  .toLowerCase();

export const downloadMassBalancePdf = async ({
  totals,
  varietyName,
  warehouseLabel,
  desde,
  hasta,
}) => {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const logoDataUrl = await loadPdfReportLogo();
  drawPdfReportHeader(doc, {
    logoDataUrl,
    pageNumber: 1,
    totalPages: 1,
    title: 'BALANCE DE MASAS',
    subtitle: `Periodo: ${formatDisplayDate(desde)} - ${formatDisplayDate(hasta)}`,
    rightDetail: '',
  });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(...dark);
  const varietyLines = doc.splitTextToSize(`Variedad: ${varietyName}`, 176);
  doc.text(varietyLines, 16, 37);
  const warehouseY = 39 + varietyLines.length * 5;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(...muted);
  const warehouseLines = doc.splitTextToSize(`Almacenes: ${warehouseLabel}`, 176);
  doc.text(warehouseLines, 16, warehouseY);

  const headerTop = warehouseY + 5 + warehouseLines.length * 5;
  doc.setFillColor(248, 249, 250);
  doc.roundedRect(14, headerTop, 182, 15, 1.5, 1.5, 'F');
  doc.setTextColor(...orange);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('ACUMULADOS', 18, headerTop + 6);
  doc.setFontSize(8);
  doc.text('Kilos', 148, headerTop + 11, { align: 'right' });
  doc.text('Porcentaje', 191, headerTop + 11, { align: 'right' });

  rows.forEach((row, index) => {
    const y = headerTop + 25 + index * 10;
    if (row.dividerBefore) {
      doc.setDrawColor(...divider);
      doc.line(16, y - 5, 194, y - 5);
    }

    if (row.emphasis) {
      doc.setFillColor(255, 247, 239);
      doc.roundedRect(14, y - 6, 182, 10, 1.5, 1.5, 'F');
    }

    doc.setTextColor(...dark);
    doc.setFont('helvetica', row.emphasis || row.label === 'Kilos reales' ? 'bold' : 'normal');
    doc.setFontSize(9);
    doc.text(row.label, 18, y);

    if (row.field) {
      doc.text(`${formatKilos(totals[row.field])} kg`, 148, y, { align: 'right' });
    }

    if (row.percentage) {
      doc.text(`${formatPercent(totals.percentages[row.percentage])} %`, 191, y, { align: 'right' });
    }
  });

  doc.save(`balance-masas-${filenamePart(varietyName)}-${desde}-${hasta}.pdf`);
};
